import { Component, OnInit, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { ControllerForViewBase } from '../../framework/controller-for-view-base';
import { PageContainerService } from '../../../services';
import { CanComponentDeactivate } from '../../../services/can-deactivate-guard.service';
import { ActivatedRoute, Params } from '@angular/router';
import { GetCheckpointCommandRequest, SecurityCheckpointDto, ValueTextSelectedDto, SaveCheckpointCommandRequest } from '../../../data/CommandServiceDtos.generated';
import * as $ from 'jquery';

@Component({
  standalone: false,
  selector: 'checkpoint',
  templateUrl: './checkpoint.component.html',
  styleUrls: ['./checkpoint.component.scss']
})
export class CheckpointComponent extends ControllerForViewBase implements OnInit, CanComponentDeactivate {

  @ViewChild('form') form: NgForm;
  public model: SecurityCheckpointDto = new SecurityCheckpointDto();
  public roles: ValueTextSelectedDto[] = [];


  constructor(public pcs: PageContainerService,
    public activatedRoute: ActivatedRoute) {
    super(pcs);
    this.pcs.actionLinksPanelService.addBackButton();
    this.pcs.actionLinksPanelService.addActionLinks([{
      text: 'Save ',
      fontAwesomeIcon: 'save',
      onClick: () => { this.submit() }
    }]);
    this.pcs.actionLinksPanelService.addActionLinks([{
      text: 'Save and Close',
      fontAwesomeIcon: 'save',
      onClick: () => { this.submit(true) }
    }]);
  }
  ngOnInit() {
    this.activatedRoute.params.subscribe((params: Params) => {
      this.load(+params['id']);
    });
  }

  async load(id: number) {
    var payload: GetCheckpointCommandRequest = {
      SecurityCheckpointId: id
    };

    let response = await this.pcs.apiService.GetCheckpoint(payload, true, false);
    this.model = response.SecurityCheckpoint;
    this.roles = response.Roles;
  }

  showCheckpointLookup() {
    $('#checkpointLookup').modal('show');
  }

  checkpointSelected(checkpoint: SecurityCheckpointDto) {
    this.model = checkpoint;
  }

  canDeactivate(): Promise<boolean> {
    var promise = Promise.resolve(true);
    if (this.form.dirty) {
      return this.pcs.showUnsavedChangesDialog();
    }
    return promise;
  }

  async submit(navigateaway: boolean = false): Promise<void> {
    var payload: SaveCheckpointCommandRequest = {
      Roles: this.roles,
      SecurityCheckpoint: this.model
    }
    let saveResponse = await this.pcs.apiService.SaveCheckpoint(payload, undefined, true);
    if (saveResponse.Id !== 0) {
      this.form.form.markAsPristine();
      this.updateUrlForNewEntity(['/checkpoint', saveResponse.Id]);
      if (navigateaway) {
        window.history.back();
      } else {
        this.load(saveResponse.Id);
      }
    }
  }
}
